import { ApiEndpointUrl } from "../../common";
export const reviewPoint = {
    create_review:(productid)=> ApiEndpointUrl + "reviews/"+productid+"/create",
    list:ApiEndpointUrl + "reviews"
};


